import { useState, useEffect } from 'react';
import AllMarkdown from './allmarkdown.js';
import Typewriter from 'typewriter-effect';

import { execSeatableSql } from './seatable.js';
import Stats from './stats.js';
import AI from './ai.js';
import Services from './services.js';
import ListCapabilities from './listcapabilities.js';
import Segments from './segments.js';
import Artifacts from './artifacts.js';
import Clients from './clients.js';
import Quotes from './quotes.js';
import TechStack from './techstack.js';
import Leaders from './leaders.js';
import Footer from "./footer";

const HOME_VIDEO = 'https://media.allteam.com/media/Allteam_Website/hero_section/14471939_3840_2160_30fps.mp4';
const homePage = 'Home Page';

function Home(props) {
    return (
          <div>
            <HomeContent />
            <div className="nav-buffer" />
            <Stats capability={homePage} />
            <AI capability={homePage} />
            <Services capability={homePage} />
            <ListCapabilities type="Services" />
            <Segments capability={homePage} />
            <ListCapabilities type="Segments" />
            <Artifacts capability={homePage} />
            <Clients capability={homePage} />
            <Quotes capability={homePage} />
            <TechStack capability={homePage} />
            <Leaders capability={homePage} />
            <Footer />
          </div>
    )
}

function HomeContent() {
    const [data, setData] = useState(null);

    useEffect(() => {
      async function fetchData() {
        const sql = `SELECT * FROM CapabilitySections WHERE \`Capability\` = 'Home Page' AND \`PageSection\` = 'Hero'`;
        setData(null);

        try {
          const rows = await execSeatableSql(sql);
          setData(rows && rows.results[0]);
        } catch (err) {
          // setError(err);
        }
      }
      fetchData();
    }, []);

    return (
      <div id="top" className="home">
          <video className="home-video" loop autoPlay muted playsInline>
              <source src={HOME_VIDEO} type="video/mp4"/>
          </video>
          <div className="home-content">
              <div className="home-title">{data && data["Section Title"]}</div>
              <div className="home-desc">
                  <div className="my-5 my-md-5 text-center">
                    <AllMarkdown>{data && data["Section Sub Headline"]}</AllMarkdown>
                  </div>
                  {/* <Button>Learn more</Button> */}
              </div>
              {data && data.HeroScrollingText && (data.HeroScrollingText.length > 0) ? (
              <div>
                  <Typewriter options={{
                      strings: data && data.HeroScrollingText.map(row => row.display_value), 
                      autoStart: true, 
                      loop: true, 
                      cursor: '_',
                      delay: '50',
                      wrapperClassName: "home-typing",
                      }} />
              </div>
              ) : ''}
          </div>
      </div>
    )

}

export default Home;